// extracted by css-extract-rspack-plugin
export default {"editor":"u0yp2","tag":"EsiaI"};